import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Download, Smartphone } from 'lucide-react';

/**
 * Botones de instalación PWA (Android nativo + dialog para iOS).
 * Captura el evento `beforeinstallprompt` para Android/Chrome y abre un dialog
 * con instrucciones para iOS Safari.
 */
export default function InstallButtons({ variant = 'dark' }) {
  const [promptEvt, setPromptEvt] = useState(null);
  const [iosOpen, setIosOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPromptEvt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const installAndroid = async () => {
    if (!promptEvt) {
      window.location.href = '/mobile';
      return;
    }
    promptEvt.prompt();
    await promptEvt.userChoice;
    setPromptEvt(null);
  };

  const androidCls = variant === 'dark'
    ? 'bg-slate-950 hover:bg-slate-800 text-white'
    : 'bg-white text-slate-950 hover:bg-slate-100';
  const iosCls = variant === 'dark'
    ? 'border-2 border-slate-300 text-slate-900 bg-white/95 hover:bg-white'
    : 'border-2 border-white/80 text-white bg-transparent hover:bg-white/10';

  return (
    <>
      <div className="flex flex-col sm:flex-row gap-3" data-testid="landing-pwa-buttons">
        <Button onClick={installAndroid} className={`${androidCls} rounded-full px-6 h-12`} data-testid="landing-android-download-btn">
          <Download className="w-4 h-4 mr-2" /> Instalar app Android
        </Button>
        <Button variant="outline" onClick={() => setIosOpen(true)} className={`${iosCls} rounded-full px-6 h-12`} data-testid="landing-ios-download-btn">
          <Smartphone className="w-4 h-4 mr-2" /> Instalar app iPhone
        </Button>
      </div>

      <Dialog open={iosOpen} onOpenChange={setIosOpen}>
        <DialogContent className="bg-white border-slate-200 max-w-lg" data-testid="ios-install-dialog">
          <DialogHeader>
            <DialogTitle className="text-slate-900">Instalación en iPhone</DialogTitle>
          </DialogHeader>
          <div className="space-y-3 text-sm text-slate-600">
            <p>1) Abre la app móvil en Safari.</p>
            <p>2) Toca Compartir.</p>
            <p>3) Elige <strong className="text-slate-900">Agregar a pantalla de inicio</strong>.</p>
            <Button className="w-full" onClick={() => { window.location.href = '/mobile'; }} data-testid="ios-open-mobile-app">
              Abrir app móvil
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
